class AdminRoomApiClient {
  constructor(client) {
    this.client = client
  }

  index(values) {
    const params = { ...values }

    return this.client.get('admin/v1/rooms', { params }).then((res) => res.data)
  }

  show(roomId) {
    return this.client.get(`admin/v1/rooms/${roomId}`).then((res) => res.data)
  }

  fetchRoomMessages(roomId) {
    return this.client.get(`admin/v1/rooms/${roomId}/messages`).then((response) => response.data)
  }

  fetchRoomReviews(roomId) {
    return this.client.get(`admin/v1/rooms/${roomId}/reviews`).then((response) => response.data)
  }

  fetchRoomTrackings(roomId) {
    return this.client.get(`admin/v1/rooms/${roomId}/trackings`).then((response) => response.data)
  }

  postRoomReview(roomId, data) {
    return this.client.post(`admin/v1/rooms/${roomId}/reviews`, data).then((response) => response.data)
  }

  // ADMIN ACTIONS
  demandRoomRating(roomId, data = { data: [] }) {
    return this.client.post(`admin/v1/rooms/${roomId}/send-rating`, data)
  }

  setRoomNeedToAnswer(roomId) {
    return this.client.put(`admin/v1/rooms/${roomId}/question`)
  }

  unSetRoomNeedToAnswer(roomId) {
    return this.client.put(`admin/v1/rooms/${roomId}/answer`)
  }

  setRoomNeedToRead(roomId) {
    return this.client.put(`admin/v1/rooms/${roomId}/unread`)
  }

  unSetRoomNeedToRead(roomId) {
    return this.client.put(`admin/v1/rooms/${roomId}/read`)
  }

  activateRoom(roomId) {
    return this.client.put(`admin/v1/rooms/${roomId}/activate`)
  }
  deActivateRoom(roomId) {
    return this.client.put(`admin/v1/rooms/${roomId}/deactivate`)
  }

  //TODO: actions activate and deactivate in bulk are not supported on consultations api yet
  bulkDeactivate(roomIds) {
    return this.client.put('admin/v1/rooms/bulk-deactivate', { room_ids: roomIds })
  }

  bulkActivate(roomIds) {
    return this.client.put('admin/v1/rooms/bulk-activate', { room_ids: roomIds })
  }
}

export default AdminRoomApiClient
